// Počet u položky menu „Požadavky na svoz (n)“ (4.8): čekající požadavky (`PozadavekSvozuSeznam.ceka`) pro role,
// které plánují (admin, jednatel, dispečer, koordinátor — akce `svoz_pozadavek.planovat`). Nula se neukazuje;
// žadatelské role počet nemají (vidí jen své požadavky).
import { AKCE_PLANOVAT_SVOZ, usePocetSvozuCeka } from '../api/svoz-pozadavky';
import { usePrihlaseni } from '../prihlaseni/stav-prihlaseni';
import './Shell.css';

/** `testId` jiný než výchozí — spodní lišta na telefonu počet ukazuje vedle menu (krok 13.7a). */
export function PocetSvozu({ testId = 'pocet-svozu' }: { testId?: string } = {}) {
  const { ja } = usePrihlaseni();
  const povoleno = Boolean(
    ja &&
    (ja.sekce ?? []).includes('svoz_pozadavky') &&
    (ja.akce ?? []).includes(AKCE_PLANOVAT_SVOZ),
  );
  const pocet = usePocetSvozuCeka(povoleno);
  if (!povoleno || pocet.data === undefined || pocet.data === 0) return null;
  return (
    <span
      className="lista__pocet"
      data-testid={testId}
      aria-label={`${pocet.data} požadavků na svoz čeká na naplánování`}
      title={`Čeká na dispečera: ${pocet.data}`}
    >
      {pocet.data}
    </span>
  );
}
